module.exports = __webpack_public_path__ + "static/media/2_The inner voice_CN.4aa1b377.txt";